module.exports = __webpack_public_path__ + "img/integration-zero-latency.svg";